import { Shield, FileText, Receipt, Scale } from "lucide-react";
import CTAButtons from "./CTAButtons";

const defaultCards = [
  {
    Icon: FileText,
    title: "Can I leave whenever I want?",
    body: "Yes. Our agreement runs month to month with 30 days' notice. Block any dates you want the property back, no questions asked. No lock-in, no penalties, no eviction process.",
  },
  {
    Icon: Shield,
    title: "What if a guest damages my property?",
    body: "Every guest is ID-verified before they book. We cover you up to £50,000 directly, and Airbnb's Aircover adds up to $3 million on top. In 35,000+ stays we've never had an uninsured claim.",
  },
  {
    Icon: Receipt,
    title: "What does it actually cost me?",
    body: "From 12% + VAT, charged only on nights that book, so if your property sits empty, you pay nothing. A one-off £150 onboarding fee covers setup. Cleaning is paid by the guest, not you.",
  },
  {
    Icon: Scale,
    title: "Is short-letting even allowed on my property?",
    body: "Manchester has no licensing requirement and no night cap. We check your lease, mortgage and insurance for restrictions, arrange any safety certificates, and handle compliance end to end, so you don't have to worry.",
  },
];

export default function ManchesterRiskReversal({ config }) {
  const cityName = config?.cityName || "Manchester";

  const getComplianceBody = (name) => {
    if (name === "London") {
      return "London has a 90-night cap on short-lets per year without planning permission. We track your nights automatically, can apply for planning permission on your behalf, and handle compliance end to end, so you don't have to worry.";
    }
    if (name === "Dubai") {
      return "Dubai requires a DTCM holiday home licence to short-let legally. We handle the entire licence application, renewal, and compliance end to end, so you don't have to worry.";
    }
    return `${name} has no licensing requirement and no night cap. We check your lease, mortgage and insurance for restrictions, arrange any safety certificates, and handle compliance end to end, so you don't have to worry.`;
  };

  const cards = defaultCards.map((c, i) =>
    i === 3 ? { ...c, body: getComplianceBody(cityName) } : c
  );
  return (
    <section style={{ background: "linear-gradient(to bottom, #FFFFFF 0%, #F4F1E7 100%)", padding: "clamp(60px,7vw,96px) clamp(20px,5vw,80px)" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: 48 }}>
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", color: "#5C7268", marginBottom: 12, marginTop: 0 }}>
            Straight answers
          </p>
          <h2 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: "clamp(28px,4vw,44px)", letterSpacing: "-0.02em", lineHeight: 1.15, color: "#112215", margin: "0 auto 16px", maxWidth: 620 }}>
            The four most common concerns
          </h2>
          <p style={{ fontFamily: "'Inter', sans-serif",             fontSize: 16, color: "#5C7268", lineHeight: 1.65, maxWidth: 560, margin: "0 auto" }}>
            Straight answers to the questions you are actually asking. No hedging.
          </p>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 16, alignItems: "stretch" }} className="rr-grid">
          {cards.map(({ Icon, title, body }, i) => {
            const cardBgs = ["#F3EBE3", "#EBEDE8", "#E2EDE0", "#D8E9D4"];
            return (
            <div
              key={title}
              style={{
                background: cardBgs[i],
                borderRadius: 16,
                padding: "28px 24px",
                display: "flex",
                flexDirection: "column",
                border: "1px solid #E8E4D5",
                minHeight: 280,
                height: "100%",
              }}
            >
              <div style={{ width: 38, height: 38, borderRadius: 10, background: "#FFFFFF", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginBottom: 16 }}>
                <Icon size={18} color="#112215" strokeWidth={1.8} />
              </div>
              <p style={{ fontFamily: "'Inter', sans-serif", fontWeight: 600, fontSize: 21, color: "#112215", margin: "0 0 10px", letterSpacing: "-0.01em" }}>{title}</p>
              <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 13.5, color: "#5C7268", lineHeight: 1.6, margin: 0 }}>
                {body}
              </p>
            </div>
            );
          })}
        </div>

        {/* Risk-reversal strap */}
        <div style={{ marginTop: 40, textAlign: "center" }}>
          <p style={{ fontFamily: "'Inter', sans-serif",             fontSize: 18, fontWeight: 600, color: "#112215", margin: "0 0 28px", lineHeight: 1.5 }}>
            No long lock-in. Cancel with 30 days' notice. Transparent fees, nothing hidden.
          </p>
          <CTAButtons includeMicrocopy />
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) { .rr-grid { grid-template-columns: repeat(2, 1fr) !important; } }
        @media (max-width: 480px) { .rr-grid { grid-template-columns: 1fr !important; } }
      `}</style>
    </section>
  );
}